import Character from "@lss/common/src/shell/Character";
import { GameVersion } from "../../src/shell/Game";
import { v6EmilyShoppingWindowDress } from "../../src/shell/PropertiesDeclarations";

interface GlobalsPropertiesINT {
    playedVersion: GameVersion | '';

}

const globalsProperties: GlobalsPropertiesINT = {
    playedVersion: ''
};


const globals = new Character<GlobalsPropertiesINT>("globals", globalsProperties, "#6391FFFF");

export {
    globals,
};
